import styled, { css } from 'styled-components';

import { Text, theme as yoga } from '@gympass/yoga';
import { wellzTheme } from '@wellz-theme/mui';

import { MessageProps } from './types';

export const MessageBlockContainer = styled.div`
  flex-direction: column-reverse;
`;

export const TitleDate = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.deep};
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const Block = styled.ul`
  display: flex;
  flex-direction: column-reverse;
`;

// ask why we have here duplicated d
const radiiStart = (props: MessageProps) =>
  props.theme.yoga.radii[props.$messageStart ? 'regular' : 'xsmall'];
const radiiEnd = (props: MessageProps) =>
  props.theme.yoga.radii[props.$messageEnd ? 'regular' : 'xsmall'];

const messageModifiers = {
  endUser: () => css`
    align-self: start;

    background-color: ${wellzTheme.palette.background.default};
    color: ${wellzTheme.palette.text.primary};

    margin-left: ${wellzTheme.spacing(3)};
    border-top-right-radius: ${yoga.radii.regular}px;
    border-bottom-right-radius: ${yoga.radii.regular}px;
    border-top-left-radius: ${radiiStart}px;
    border-top-left-radius: ${radiiStart}px;
    border-bottom-left-radius: ${radiiEnd}px;
    border-bottom-left-radius: ${radiiEnd}px;

    @media screen and (max-width: 1024px) {
      margin-left: ${wellzTheme.spacing(1.5)};
    }
  `,
  careProvider: () => css`
    align-self: end;

    background-color: ${wellzTheme.palette.primary.main};
    color: ${wellzTheme.palette.info.contrastText};

    margin-right: ${wellzTheme.spacing(3)};
    border-top-left-radius: ${yoga.radii.regular}px;
    border-bottom-left-radius: ${yoga.radii.regular}px;
    border-top-right-radius: ${radiiStart}px;
    border-top-right-radius: ${radiiStart}px;
    border-bottom-right-radius: ${radiiEnd}px;
    border-bottom-right-radius: ${radiiEnd}px;

    @media screen and (max-width: 1024px) {
      margin-right: ${wellzTheme.spacing(1.5)};
    }
  `,
  end: () => css`
    margin-bottom: ${wellzTheme.spacing(3)};
  `,
  start: () => css`
    margin-bottom: ${wellzTheme.spacing(1)};
  `,
};

export const Message = styled<MessageProps>(Text.Small).attrs({ as: 'li' })`
  ${({ $isCpMessage, $messageEnd }) => css`
    display: flex;
    flex-direction: column;
    align-items: end;

    padding: ${wellzTheme.spacing(2)} ${wellzTheme.spacing(2.5)};

    max-width: 80%;

    ${$isCpMessage ? messageModifiers.careProvider : messageModifiers.endUser};
    ${$messageEnd ? messageModifiers.end : messageModifiers.start};
  `}
`;

export const MessageBody = styled(Text.Small)`
  color: inherit;
  word-wrap: break-word;
  width: 100%;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const MessageTime = styled(Text.Tiny)`
  margin-top: 4px;
  color: inherit;
  opacity: 0.7;
`;

export const MessageTyping = styled.div`
  margin-left: ${wellzTheme.spacing(3)};
  border-top-right-radius: ${yoga.radii.regular}px;
  border-bottom-right-radius: ${yoga.radii.regular}px;
  border-top-left-radius: ${radiiStart}px;
  border-top-left-radius: ${radiiStart}px;
  border-bottom-left-radius: ${radiiEnd}px;
  border-bottom-left-radius: ${radiiEnd}px;

  display: inline-flex;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.small}px;
  background-color: ${({ theme }) => theme.yoga.colors.white};
  padding: ${({ theme }) =>
    `${theme.yoga.spacing.small}px ${theme.yoga.spacing.medium}px`};

  @media screen and (max-width: 1024px) {
    margin-left: ${wellzTheme.spacing(1.5)};
  }
`;

const dot = css`
  color: ${({ theme }) => theme.yoga.colors.primary};
  width: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  height: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  border-radius: ${({ theme }) => theme.yoga.radii.regular}px;
  background-color: ${({ theme }) => theme.yoga.colors.primary};
`;

export const DotsTyping = styled.div`
  ${dot}
  margin:${({ theme }) => theme.yoga.spacing.xxxsmall}px ${({ theme }) =>
    theme.yoga.spacing.medium}px;
  position: relative;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;

  &::before,
  &::after {
    ${dot}
    top: 0;
    content: '';
    display: inline-block;
    position: absolute;
  }

  &::before {
    left: -15px;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
  }

  &::after {
    left: 15px;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes dotFlashing {
    0% {
      background-color: ${({ theme }) => theme.yoga.colors.primary};
    }
    50%,
    100% {
      background-color: ${({ theme }) => theme.yoga.colors.secondary};
    }
  }
`;
